import { Injectable } from "@angular/core";
import workerScript from "../Cases/worker";

@Injectable({ providedIn: 'root' })
export class TimeWorkerService {
  private worker: Worker | undefined;
  private uniqueTimestamp: number | null = null;
  public dateNow: string = '';
  public dayName: string = '';
  public istimestamp: boolean = false;

  constructor(
    // private timestampService: TimestampService
  ) {}

  getTimeStamp() {
    const labTimezone = localStorage.getItem("defaultTz");
    const language = localStorage.getItem("language");
       
        try {
            const timezone = labTimezone || "UTC";
            const lang = language || "en";

            const convertedTime = new Date().toLocaleString("en-US", {
                timeZone: timezone,
            });

            const date = new Date(convertedTime);
            this.dateNow = date.toISOString();

            const dayName = new Intl.DateTimeFormat(lang, {
                weekday: "long",
            }).format(date);
            this.dayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);
        } catch (error) {
            console.error("Error in getTimeStamp:", error);

            const date = new Date();
            this.dateNow = date.toISOString();

            const lang = language || "en";
            const dayName = new Intl.DateTimeFormat(lang, {
                weekday: "long",
            }).format(date);
            this.dayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);
        }
    }

  // public initWorker(labTimezone: string, language: string) {
  //   if (typeof Worker !== 'undefined' && !this.worker) {
  //     this.worker = new Worker(workerScript);

  //     this.worker.onmessage = ({ data }) => {
  //       if (data.type === 'tick' && data.label === 'startWatch') {
  //         this.setWatchTimer(labTimezone, language);
  //       }
  //     };

  //     this.worker.postMessage({
  //       type: 'start',
  //       label: 'startWatch',
  //       delay: 1000,
  //     });
  //   }
  // }

  setWatchTimer(labTimezone: string, language: string) {
    if (this.uniqueTimestamp) {
      // this.uniqueTimestamp += 1000;
      this.istimestamp = true;
      const convertedTime = new Date(this.uniqueTimestamp).toLocaleString('en-US', { timeZone: labTimezone });
      const dateInLabTZ = new Date(convertedTime);
      this.dateNow = dateInLabTZ.toISOString();

      const day = new Intl.DateTimeFormat(language, { weekday: 'long' }).format(dateInLabTZ);
      this.dayName = day.charAt(0).toUpperCase() + day.slice(1);
    } else {
      this.getTimeStamp();
    }
  }

  setInitialTimestamp(ts: number) {
    this.uniqueTimestamp = ts;
  }

  hasFetched(): Boolean {
    return this.istimestamp;
  }
}
